import Vue from 'vue';
import Errors from '../../classes/Errors';

Vue.component('edit-profile', {
    props: ['initialCountries', 'memberProfile', 'successUrl'],

    data() {
        return {
            formErrors: new Errors(),
            submitting: false,
            countryCode: 'NL',
            memberCountry: null,
            phoneCountry: null,
        };
    },

    computed: {
        countries() {
            const defaultCountry = _.find(this.initialCountries, { code: 'NL' });
            const disabled = {
                disabled: true,
            };

            return [defaultCountry, disabled, ...this.initialCountries];
        },

        countriesName() {
            const filtered = _.filter(this.initialCountries, (o) => o.countryCode);

            return _.orderBy(filtered, 'name');
        },
    },

    mounted() {
        // Set countryCode from number.
        for (let country = 0; country < this.countries.length; country++) {
            if (this.countries[country].countryCode === this.memberProfile.countryCode) {
                this.countryCode = this.countries[country].code;
                this.phoneCountry = this.countries[country];
            }

            if (this.countries[country].code === this.memberProfile.country) {
                this.memberCountry = this.countries[country];
            }
        }
    },

    methods: {
        /**
         * Submit the form to the backend.
         *
         * @return {Void}
         */
        onFormSubmit() {
            // Set state
            this.submitting = true;

            const { form } = this.$refs;

            const inputs = form.querySelectorAll('input[type="file"]:not([disabled])');

            for (let index = 0; index < inputs.length; index++) {
                const input = inputs[index];
                if (input.files.length > 0) {
                    return;
                }
                input.setAttribute('disabled', '');
            }

            const formData = new FormData(form);
            for (let index = 0; index < inputs.length; index++) {
                const input = inputs[index];
                input.removeAttribute('disabled');
            }

            // Submit form
            axios.post(window.siteUrl, formData)
            .then(this.onSubmitSuccess)
            .catch(this.onSubmitError);
        },

        /**
         * Handles submission error(s).
         *
         * @return {Void}
         */
        onSubmitError(error) {
            this.submitting = false;

            this.formErrors.clear();
            zenscroll.toY(0);
            console.log(error);

            this.formErrors.record(error.data.errors);
        },

        /**
         * Handles submission success.
         *
         * @return {Void}
         */
        onSubmitSuccess(response) {
            if (!response.data.success) {
                this.onSubmitError(response);
                return;
            }

            this.formComplete = true;

            window.location.href = this.successUrl;
        },
    },
});
